<template>
    <div id="sign">
        <backHead />
        <div class="sign-content">
            <img src="../../assets/img/login.jpg" alt="">
            <!-- 注册表单 -->
            <loginForm :value="value" v-if="isLogin" @chengeIsLogin="chengeIsLogin" />
            <signForm :value="value" :Invite="Invite" v-else @chengeIsLogin="chengeIsLogin" />
        </div>
    </div>
</template>
<script>
import signForm from "./components/sign-form";
import loginForm from "./components/login-form";
import backHead from "../../components/backHead";
export default {
    name: 'sign',
    components: {
        signForm,
        backHead,
        loginForm
    },
    data() {
        return {
            refreshKey: true,
            isLogin: true,
            value: 1,
            Invite: ''
        }
    },
    mounted() {
        // console.log(this.$store.state.phone_code);
        if (this.$store.state.phone_code) {
            this.value = this.$store.state.phone_code;
        }
        if (this.$route.query.invite) {
            this.Invite = this.$route.query.invite;
            this.$store.commit('changeIsLogin', false);
        }
        this.isLogin = this.$store.state.isLogin;
    },
    methods: {
        chengeIsLogin(e) {
            this.isLogin = e;
            this.$store.commit('changeIsLogin', e);
        }
    }
}
</script>
<style lang="scss" scoped>
#sign {
    width: 100%;
    min-height: 100vh;
    color: #fff;
    position: relative;

    img {
        width: 100%;
        margin-top: -70px;
    }

    .sign-content {
        margin-top: 70px;
        padding: 20px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding-top: 62%;
        background-color: #539fe1;
        img{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
        }
    }

    .content {}
}
</style>
